module.exports = __webpack_public_path__ + "img/gml_3_splash.c0e6bc05.jpg";